import React from "react";
import { motion } from "framer-motion";

export const Section = ({
  children,
  className = "",
  id,
  spacing = "py-24 md:py-32",
}) => (
  <section id={id} className={`${spacing} ${className}`}>
    <div className="container">{children}</div>
  </section>
);

export const Overline = ({ children, className = "" }) => (
  <div className={`overline text-primary ${className}`}>— {children}</div>
);

export const SectionHeading = ({ overline, title, lead, align = "left" }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, ease: [0.2, 0.7, 0.2, 1] }}
    className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}
  >
    {overline && <Overline className="mb-4">{overline}</Overline>}
    <h2 className="font-display font-bold tracking-tight text-3xl md:text-5xl lg:text-6xl leading-[1.02]">
      {title}
    </h2>
    {lead && (
      <p className="mt-6 text-base md:text-lg text-muted-foreground leading-relaxed">
        {lead}
      </p>
    )}
  </motion.div>
);

export const FadeIn = ({ children, delay = 0, className = "", y = 18 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay, ease: [0.2, 0.7, 0.2, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);
